import { Link, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useTitle from "../../hooks/useTitle";
import { useGetProfileQuery } from "../users/usersApiSlice";
import MyMessages from "../messages/student/MyMessages";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useState } from "react";
import FinalGradesListFilter from "../finalGrade/partial/FinalGradesListFilter";
import { faMessage, faTable } from "@fortawesome/free-solid-svg-icons";
import AdminMessages from "../messages/admin/AdminMessages";

const WelcomeTabs = () => {
  const [value, setValue] = useState(0);
  const { username, name, isTeacher, isAdmin,isStudent } = useAuth()

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const content = (
    <section className="tab-section">
<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" 
   indicatorColor="primary"
          textColor="inherit"
          >
     <Tab  iconPosition="start" value={0}  icon={ <FontAwesomeIcon  style={{paddingLeft:"10px"}}  icon={faMessage} /> }  label=" הודעות "  />
    <Tab  iconPosition="start" value={1} icon={ <FontAwesomeIcon   style={{paddingLeft:"10px"}}  icon={faTable} /> }  label="גליון ציונים"  />
   
    
  </Tabs>
  {(value === 0 &&  isStudent) && <MyMessages />  }
  {(value === 0 &&  isAdmin) && <AdminMessages />  }
  {value === 1 && <FinalGradesListFilter hidePrint={true} />}
</Box>
    </section>
  );

  return content;
};
export default WelcomeTabs;
